import { PageRequest, PageResponse } from "../../../cosmos/base/query/v1beta1/pagination";
import { FeeShare } from "./feeshare";
import { Params } from "./genesis";
import { BinaryReader, BinaryWriter } from "../../../binary";
/** QueryFeeSharesRequest is the request type for the Query/FeeShares RPC method. */

/** QueryFeeSharesRequest is the request type for the Query/FeeShares RPC method. */

/** QueryFeeSharesRequest is the request type for the Query/FeeShares RPC method. */

/**
 * QueryFeeSharesResponse is the response type for the Query/FeeShares RPC
 * method.
 */

/**
 * QueryFeeSharesResponse is the response type for the Query/FeeShares RPC
 * method.
 */

/**
 * QueryFeeSharesResponse is the response type for the Query/FeeShares RPC
 * method.
 */

/** QueryFeeShareRequest is the request type for the Query/FeeShare RPC method. */

/** QueryFeeShareRequest is the request type for the Query/FeeShare RPC method. */

/** QueryFeeShareRequest is the request type for the Query/FeeShare RPC method. */

/** QueryFeeShareResponse is the response type for the Query/FeeShare RPC method. */

/** QueryFeeShareResponse is the response type for the Query/FeeShare RPC method. */

/** QueryFeeShareResponse is the response type for the Query/FeeShare RPC method. */

/** QueryParamsRequest is the request type for the Query/Params RPC method. */

/** QueryParamsRequest is the request type for the Query/Params RPC method. */

/** QueryParamsRequest is the request type for the Query/Params RPC method. */

/** QueryParamsResponse is the response type for the Query/Params RPC method. */

/** QueryParamsResponse is the response type for the Query/Params RPC method. */

/** QueryParamsResponse is the response type for the Query/Params RPC method. */

/**
 * QueryDeployerFeeSharesRequest is the request type for the
 * Query/DeployerFeeShares RPC method.
 */

/**
 * QueryDeployerFeeSharesRequest is the request type for the
 * Query/DeployerFeeShares RPC method.
 */

/**
 * QueryDeployerFeeSharesRequest is the request type for the
 * Query/DeployerFeeShares RPC method.
 */

/**
 * QueryDeployerFeeSharesResponse is the response type for the
 * Query/DeployerFeeShares RPC method.
 */

/**
 * QueryDeployerFeeSharesResponse is the response type for the
 * Query/DeployerFeeShares RPC method.
 */

/**
 * QueryDeployerFeeSharesResponse is the response type for the
 * Query/DeployerFeeShares RPC method.
 */

/**
 * QueryWithdrawerFeeSharesRequest is the request type for the
 * Query/WithdrawerFeeShares RPC method.
 */

/**
 * QueryWithdrawerFeeSharesRequest is the request type for the
 * Query/WithdrawerFeeShares RPC method.
 */

/**
 * QueryWithdrawerFeeSharesRequest is the request type for the
 * Query/WithdrawerFeeShares RPC method.
 */

/**
 * QueryWithdrawerFeeSharesResponse is the response type for the
 * Query/WithdrawerFeeShares RPC method.
 */

/**
 * QueryWithdrawerFeeSharesResponse is the response type for the
 * Query/WithdrawerFeeShares RPC method.
 */

/**
 * QueryWithdrawerFeeSharesResponse is the response type for the
 * Query/WithdrawerFeeShares RPC method.
 */

function createBaseQueryFeeSharesRequest() {
  return {
    pagination: undefined
  };
}
export const QueryFeeSharesRequest = {
  typeUrl: "/juno.feeshare.v1.QueryFeeSharesRequest",
  encode(message, writer = BinaryWriter.create()) {
    if (message.pagination !== undefined) {
      PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeSharesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.pagination = PageRequest.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryFeeSharesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeeSharesRequest();
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageRequest.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeeSharesRequest.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeeSharesRequest.decode(message.value);
  },
  toProto(message) {
    return QueryFeeSharesRequest.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryFeeSharesRequest",
      value: QueryFeeSharesRequest.encode(message).finish()
    };
  }
};
function createBaseQueryFeeSharesResponse() {
  return {
    feeshare: [],
    pagination: undefined
  };
}
export const QueryFeeSharesResponse = {
  typeUrl: "/juno.feeshare.v1.QueryFeeSharesResponse",
  encode(message, writer = BinaryWriter.create()) {
    for (const v of message.feeshare) {
      FeeShare.encode(v, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeSharesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.feeshare.push(FeeShare.decode(reader, reader.uint32()));
          break;
        case 2:
          message.pagination = PageResponse.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$feeshare;
    const message = createBaseQueryFeeSharesResponse();
    message.feeshare = ((_object$feeshare = object.feeshare) === null || _object$feeshare === void 0 ? void 0 : _object$feeshare.map(e => FeeShare.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    var _object$feeshare2;
    const message = createBaseQueryFeeSharesResponse();
    message.feeshare = ((_object$feeshare2 = object.feeshare) === null || _object$feeshare2 === void 0 ? void 0 : _object$feeshare2.map(e => FeeShare.fromAmino(e))) || [];
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageResponse.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    if (message.feeshare) {
      obj.feeshare = message.feeshare.map(e => e ? FeeShare.toAmino(e) : undefined);
    } else {
      obj.feeshare = [];
    }
    obj.pagination = message.pagination ? PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeeSharesResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeeSharesResponse.decode(message.value);
  },
  toProto(message) {
    return QueryFeeSharesResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryFeeSharesResponse",
      value: QueryFeeSharesResponse.encode(message).finish()
    };
  }
};
function createBaseQueryFeeShareRequest() {
  return {
    contractAddress: ""
  };
}
export const QueryFeeShareRequest = {
  typeUrl: "/juno.feeshare.v1.QueryFeeShareRequest",
  encode(message, writer = BinaryWriter.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeShareRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$contractAddre;
    const message = createBaseQueryFeeShareRequest();
    message.contractAddress = (_object$contractAddre = object.contractAddress) !== null && _object$contractAddre !== void 0 ? _object$contractAddre : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeeShareRequest();
    if (object.contract_address !== undefined && object.contract_address !== null) {
      message.contractAddress = object.contract_address;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeeShareRequest.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeeShareRequest.decode(message.value);
  },
  toProto(message) {
    return QueryFeeShareRequest.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryFeeShareRequest",
      value: QueryFeeShareRequest.encode(message).finish()
    };
  }
};
function createBaseQueryFeeShareResponse() {
  return {
    feeshare: FeeShare.fromPartial({})
  };
}
export const QueryFeeShareResponse = {
  typeUrl: "/juno.feeshare.v1.QueryFeeShareResponse",
  encode(message, writer = BinaryWriter.create()) {
    if (message.feeshare !== undefined) {
      FeeShare.encode(message.feeshare, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeShareResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.feeshare = FeeShare.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryFeeShareResponse();
    message.feeshare = object.feeshare !== undefined && object.feeshare !== null ? FeeShare.fromPartial(object.feeshare) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeeShareResponse();
    if (object.feeshare !== undefined && object.feeshare !== null) {
      message.feeshare = FeeShare.fromAmino(object.feeshare);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.feeshare = message.feeshare ? FeeShare.toAmino(message.feeshare) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeeShareResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeeShareResponse.decode(message.value);
  },
  toProto(message) {
    return QueryFeeShareResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryFeeShareResponse",
      value: QueryFeeShareResponse.encode(message).finish()
    };
  }
};
function createBaseQueryParamsRequest() {
  return {};
}
export const QueryParamsRequest = {
  typeUrl: "/juno.feeshare.v1.QueryParamsRequest",
  encode(_, writer = BinaryWriter.create()) {
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },
  fromAmino(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },
  toAmino(_) {
    const obj = {};
    return obj;
  },
  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },
  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }
};
function createBaseQueryParamsResponse() {
  return {
    params: Params.fromPartial({})
  };
}
export const QueryParamsResponse = {
  typeUrl: "/juno.feeshare.v1.QueryParamsResponse",
  encode(message, writer = BinaryWriter.create()) {
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.params = Params.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryParamsResponse();
    if (object.params !== undefined && object.params !== null) {
      message.params = Params.fromAmino(object.params);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.params = message.params ? Params.toAmino(message.params) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },
  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }
};
function createBaseQueryDeployerFeeSharesRequest() {
  return {
    deployerAddress: "",
    pagination: undefined
  };
}
export const QueryDeployerFeeSharesRequest = {
  typeUrl: "/juno.feeshare.v1.QueryDeployerFeeSharesRequest",
  encode(message, writer = BinaryWriter.create()) {
    if (message.deployerAddress !== "") {
      writer.uint32(10).string(message.deployerAddress);
    }
    if (message.pagination !== undefined) {
      PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDeployerFeeSharesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.deployerAddress = reader.string();
          break;
        case 2:
          message.pagination = PageRequest.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$deployerAddre;
    const message = createBaseQueryDeployerFeeSharesRequest();
    message.deployerAddress = (_object$deployerAddre = object.deployerAddress) !== null && _object$deployerAddre !== void 0 ? _object$deployerAddre : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryDeployerFeeSharesRequest();
    if (object.deployer_address !== undefined && object.deployer_address !== null) {
      message.deployerAddress = object.deployer_address;
    }
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageRequest.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.deployer_address = message.deployerAddress;
    obj.pagination = message.pagination ? PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryDeployerFeeSharesRequest.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryDeployerFeeSharesRequest.decode(message.value);
  },
  toProto(message) {
    return QueryDeployerFeeSharesRequest.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryDeployerFeeSharesRequest",
      value: QueryDeployerFeeSharesRequest.encode(message).finish()
    };
  }
};
function createBaseQueryDeployerFeeSharesResponse() {
  return {
    contractAddresses: [],
    pagination: undefined
  };
}
export const QueryDeployerFeeSharesResponse = {
  typeUrl: "/juno.feeshare.v1.QueryDeployerFeeSharesResponse",
  encode(message, writer = BinaryWriter.create()) {
    for (const v of message.contractAddresses) {
      writer.uint32(10).string(v);
    }
    if (message.pagination !== undefined) {
      PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDeployerFeeSharesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractAddresses.push(reader.string());
          break;
        case 2:
          message.pagination = PageResponse.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$contractAddre2;
    const message = createBaseQueryDeployerFeeSharesResponse();
    message.contractAddresses = ((_object$contractAddre2 = object.contractAddresses) === null || _object$contractAddre2 === void 0 ? void 0 : _object$contractAddre2.map(e => e)) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    var _object$contract_addr;
    const message = createBaseQueryDeployerFeeSharesResponse();
    message.contractAddresses = ((_object$contract_addr = object.contract_addresses) === null || _object$contract_addr === void 0 ? void 0 : _object$contract_addr.map(e => e)) || [];
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageResponse.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    if (message.contractAddresses) {
      obj.contract_addresses = message.contractAddresses.map(e => e);
    } else {
      obj.contract_addresses = [];
    }
    obj.pagination = message.pagination ? PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryDeployerFeeSharesResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryDeployerFeeSharesResponse.decode(message.value);
  },
  toProto(message) {
    return QueryDeployerFeeSharesResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryDeployerFeeSharesResponse",
      value: QueryDeployerFeeSharesResponse.encode(message).finish()
    };
  }
};
function createBaseQueryWithdrawerFeeSharesRequest() {
  return {
    withdrawerAddress: "",
    pagination: undefined
  };
}
export const QueryWithdrawerFeeSharesRequest = {
  typeUrl: "/juno.feeshare.v1.QueryWithdrawerFeeSharesRequest",
  encode(message, writer = BinaryWriter.create()) {
    if (message.withdrawerAddress !== "") {
      writer.uint32(10).string(message.withdrawerAddress);
    }
    if (message.pagination !== undefined) {
      PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryWithdrawerFeeSharesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.withdrawerAddress = reader.string();
          break;
        case 2:
          message.pagination = PageRequest.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$withdrawerAdd;
    const message = createBaseQueryWithdrawerFeeSharesRequest();
    message.withdrawerAddress = (_object$withdrawerAdd = object.withdrawerAddress) !== null && _object$withdrawerAdd !== void 0 ? _object$withdrawerAdd : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryWithdrawerFeeSharesRequest();
    if (object.withdrawer_address !== undefined && object.withdrawer_address !== null) {
      message.withdrawerAddress = object.withdrawer_address;
    }
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageRequest.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.withdrawer_address = message.withdrawerAddress;
    obj.pagination = message.pagination ? PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryWithdrawerFeeSharesRequest.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryWithdrawerFeeSharesRequest.decode(message.value);
  },
  toProto(message) {
    return QueryWithdrawerFeeSharesRequest.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryWithdrawerFeeSharesRequest",
      value: QueryWithdrawerFeeSharesRequest.encode(message).finish()
    };
  }
};
function createBaseQueryWithdrawerFeeSharesResponse() {
  return {
    contractAddresses: [],
    pagination: undefined
  };
}
export const QueryWithdrawerFeeSharesResponse = {
  typeUrl: "/juno.feeshare.v1.QueryWithdrawerFeeSharesResponse",
  encode(message, writer = BinaryWriter.create()) {
    for (const v of message.contractAddresses) {
      writer.uint32(10).string(v);
    }
    if (message.pagination !== undefined) {
      PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryWithdrawerFeeSharesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractAddresses.push(reader.string());
          break;
        case 2:
          message.pagination = PageResponse.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$contractAddre3;
    const message = createBaseQueryWithdrawerFeeSharesResponse();
    message.contractAddresses = ((_object$contractAddre3 = object.contractAddresses) === null || _object$contractAddre3 === void 0 ? void 0 : _object$contractAddre3.map(e => e)) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    var _object$contract_addr2;
    const message = createBaseQueryWithdrawerFeeSharesResponse();
    message.contractAddresses = ((_object$contract_addr2 = object.contract_addresses) === null || _object$contract_addr2 === void 0 ? void 0 : _object$contract_addr2.map(e => e)) || [];
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageResponse.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    if (message.contractAddresses) {
      obj.contract_addresses = message.contractAddresses.map(e => e);
    } else {
      obj.contract_addresses = [];
    }
    obj.pagination = message.pagination ? PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryWithdrawerFeeSharesResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryWithdrawerFeeSharesResponse.decode(message.value);
  },
  toProto(message) {
    return QueryWithdrawerFeeSharesResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.QueryWithdrawerFeeSharesResponse",
      value: QueryWithdrawerFeeSharesResponse.encode(message).finish()
    };
  }
};